import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import { MainService } from '../../services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-body-parts',
  templateUrl: './body-parts.component.html',
  styleUrls: ['./body-parts.component.scss'],
})
export class BodyPartsComponent implements OnInit {
  toggledParts = [];
  active_step: string;
  token: string;
  flowType: string;
  clinics: string;
  superClinicId: string;
  service: string;
  singleClinic: string;
  selectedClinic: any;
  API = this.helper.getApi();
  loading = false;
  noTherapists = false;
  human = 'assets/body_map/Artboard_1.svg';
  toggledPart = [];
  allClinics: Array<any> = this.helper.getStorage("allClinics");
  allBookings: Array<any> = this.helper.getStorage("bookings");
  selectedBodyParts: Array<any> = this.helper.getStorage("bodyParts");
  readonly bodyParts: any = Constants.BODY_PARTS;
  readonly clinicType = Constants.CLINIC_TYPE;
  readonly flowName: any = Constants.FLOW_TYPE;
  readonly steps: any = Constants.STEPS;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private router: Router,
    public mainService: MainService
  ) {}

  ngOnInit() {
    this.active_step = this.steps.specify;

    this.route.queryParams.subscribe((params: Params) => {
      this.flowType = params.type;
      this.token = params.bookingToken;
      this.clinics = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.singleClinic = params.singleClinic;

      const clinicId = Array.isArray(params.clinics)
        ? params.clinics[0]
        : params.clinics;

      this.selectedClinic = this.allClinics.filter((el) => el.id === clinicId);
    });

    if (this.selectedBodyParts) {
      this.toggledPart = this.selectedBodyParts;
    }
  }

  goBack() {
    const params = {
      clinics: this.clinics,
      type: this.flowType,
      service: this.service,
      superClinicId: this.superClinicId,
      token: this.token,
      singleClinic: this.singleClinic,
    };

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    if (params.type === this.flowName.aalborg) {
      this.router.navigate(['/find-clinic'], navigationExtras);
    } else {
      this.router.navigate(['/offer-fysiq'], navigationExtras);
    }
  }

  nextStep() {
    this.mainService
      .getTherapists(this.clinics, this.clinicType.single)
      .subscribe(this.handleSuccess.bind(this));
  }

  handleSuccess(therapistData) {
    const params = {
      clinics: this.clinics,
      type: this.flowType,
      service: this.flowType === this.flowName.aalborg ? 'FY' : this.service,
      token: this.token,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // redirect to booking visit if aalborg flow
    const selected_clinic = this.allClinics.filter(
      (clinic) => clinic.id === this.clinics.toString()
    );

    if (selected_clinic) {
      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      const active_therapists = therapistData.response.filter(({ services }) =>
        services.some(({ treatment_type_id }) => treatment_type_id === (this.flowType === this.flowName.aalborg ? 'FY' : this.service))
      );

      this.handleNextRoute(active_therapists, navigationExtras, params);
    }

    document.querySelector('.booking-steps').scrollIntoView({
      behavior: 'smooth',
    });
  }

  handleNextRoute(therapists, navigationExtras, params) {

    if (therapists.length > 0) {
      // store all clinic therapists in localStorage on each expert step load
      localStorage.removeItem('allClinicTherapists');
      localStorage.setItem('allClinicTherapists', JSON.stringify(therapists));

      // if no expert therapists, go to service step
      this.handleFlow(therapists, navigationExtras, params);
    } else {
      this.noTherapists = true;
      this.loading = false;
    }
  }

  handleFlow(therapists, navigationExtras, params) {

    if (this.flowType === this.flowName.aalborg) {
      const physiotherapists = therapists.map((el) => el.id);

      localStorage.setItem(
        'clinicTherapists',
        JSON.stringify(physiotherapists)
      );

      params['preselected_therapist'] = false;
      params['isExpert'] = false;
      params['bookings'] = this.allBookings ? this.allBookings.length : 0;

      localStorage.setItem(
        'selectedService',
        JSON.stringify('Sundhedsordning Ældre- og Handicapforv.')
      );

      this.router.navigate(['/booking-visit'], navigationExtras);
    } else {
      const selected_clinic = this.allClinics.filter(
        (clinic) => clinic.id === this.clinics.toString()
      );

      if (selected_clinic) {
        this.checkExpert(selected_clinic, therapists, params);
      }
    }
  }

  checkExpert(clinic, therapists, params) {
    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };
    const selected_service = clinic[0].services.find(
      (service) => service.group_code === this.service
    );

    localStorage.removeItem('selectedService');

    if (selected_service.is_expert === 1) {
      this.router.navigate(['/expert'], navigationExtras);
    } else {
      const physiotherapists = therapists.map((el) => el.id);

      localStorage.setItem(
        'clinicTherapists',
        JSON.stringify(physiotherapists)
      );

      params['noExperts'] = true;
      params['preselected_therapist'] = false;
      params['isExpert'] = false;
      params['bookings'] = this.allBookings ? this.allBookings.length : 0;

      this.router.navigate(['/service'], navigationExtras);
    }
  }

  handleError() {
    this.noTherapists = true;
    this.loading = false;
  }

  toggleBodyPart(toggledParts: any): void {
    this.toggledParts = toggledParts;
  }

  resetToggledParts() {
    this.toggledPart = [];
  }

  markBodyParts(event: any) {
    const val = event.target.value;

    if (event.target.checked) {
      this.toggledPart = _.union([], [val]);
    } else {
      this.toggledPart = _.reject(this.toggledPart, function (part) {
        return part === val;
      });
    }

    localStorage.setItem('bodyParts', JSON.stringify(this.toggledPart));
  }

  prefillFromURL(event) {
    this.markBodyParts(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/body-parts/body-parts.component.ts